import { AppConfigOverride } from '@abstractTypes/envs'
import { ProductTypeValues } from '@abstractTypes/filter'
import { FaPlaylistType } from '@abstractTypes/frameAdvisor'

const getPvEnvVariables = () => {
  const pvEnvVariables: AppConfigOverride = {
    shopperSlug: 'pv',
    shopperName: 'PEARLE VISION',
    storeID: '6321',
    storeLang: 'en-US',
    default: {
      productType: ProductTypeValues.OPTICAL,
      faPlaylistType: FaPlaylistType.OPTICAL,
    },
    vmStore: 'pv',
    vmStyle: 'pv',
  }

  return pvEnvVariables
}

export default getPvEnvVariables
